import React, { FC } from 'react';
import { SVGProps } from '@utils';
import { SvgWrapper } from './SvgWrapper';

interface ArrowBottomProps extends SVGProps {
  small?: boolean;
  isReverse?: boolean
}

export const ArrowBottom: FC<ArrowBottomProps> = ({ onClick, divClassName, small, isReverse }) => (
  <SvgWrapper onClick={onClick} divClassName={divClassName}>
    <svg 
      style={isReverse ? { transform: 'rotateX(180deg)' } : {}}
      xmlns="http://www.w3.org/2000/svg" 
      width={small ? "12" : "16" }
      height={small ? "7" : "9"} 
      viewBox="0 0 16 9" 
      fill="none"
    >
      <path 
        d="M8 9L0 1.36749L1.43333 0L8 6.26502L14.5667 0L16 1.36749L8 9Z" 
        fill="#5F6368" 
      />
    </svg>
  </SvgWrapper>
);